var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.54 4.54a.65.65 0 0 1 .92 0l7 7a.65.65 0 1 1-.92.92l-5.89-5.89V19a.65.65 0 1 1-1.3 0V6.57l-5.89 5.89a.65.65 0 1 1-.92-.92l7-7Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41NDA0IDQuNTQwMzhDMTEuNzk0MyA0LjI4NjU0IDEyLjIwNTggNC4yODY1NCAxMi40NTk2IDQuNTQwMzhMMTkuNDU5NiAxMS41NDA0QzE5LjcxMzUgMTEuNzk0MiAxOS43MTM1IDEyLjIwNTggMTkuNDU5NiAxMi40NTk2QzE5LjIwNTggMTIuNzEzNSAxOC43OTQzIDEyLjcxMzUgMTguNTQwNCAxMi40NTk2TDEyLjY1IDYuNTY5MjRMMTIuNjUgMTlDMTIuNjUgMTkuMzU5IDEyLjM1OSAxOS42NSAxMiAxOS42NUMxMS42NDEgMTkuNjUgMTEuMzUgMTkuMzU5IDExLjM1IDE5TDExLjM1IDYuNTY5MjRMNS40NTk2NSAxMi40NTk2QzUuMjA1ODEgMTIuNzEzNSA0Ljc5NDI1IDEyLjcxMzUgNC41NDA0MSAxMi40NTk2QzQuMjg2NTcgMTIuMjA1OCA0LjI4NjU3IDExLjc5NDIgNC41NDA0MSAxMS41NDA0TDExLjU0MDQgNC41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";